import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Button from "../../components/button/Button";
import AuthTextInput from "../../components/inputs/authTextInput/AuthTextInput";
import Loader from "../../components/loader/Loader";
import TextWrapper from "../../components/textWrapper/TextWrapper";
import { login } from "../../features/user/userSlice";
import styles from "./loginPage.module.css";

const LoginPage = () => {
  const [adminName, setAdminName] = useState("");
  const [password, setPassword] = useState("");

  const { status } = useSelector((state) => state.user);

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const handleSignIn = async (e) => {
    e.preventDefault();
    const credentials = { name: adminName, password };

    try {
      await dispatch(login(credentials)).unwrap();
      // localStorage is set inside the thunk before fulfilled fires
      navigate("/dashboard", { replace: true });
    } catch (error) {}
  };

  return status === "loading" ? (
    <div className={styles.loaderContainer}>
      <Loader />
    </div>
  ) : (
    <div className={styles.container}>
      <form className={styles.loginForm}>
        <TextWrapper textStyle={"textTitle"}>تسجيل دخول</TextWrapper>
        <div className={styles.inputsContainer}>
          <AuthTextInput
            placeholder={"اسم المستخدم"}
            height={"41px"}
            width={"446px"}
            borderRadius={"8px"}
            bgColor={"grey"}
            value={adminName}
            setValue={setAdminName}
          />
          <AuthTextInput
            placeholder={"كلمة السر"}
            height={"41px"}
            width={"446px"}
            borderRadius={"8px"}
            bgColor={"grey"}
            value={password}
            setValue={setPassword}
            isPassword={true}
          />
        </div>
        <Button
          size={"bigSize"}
          variant={"blackVariant"}
          functionallity={handleSignIn}
        >
          <TextWrapper textStyle={"textMid"}>تسجيل دخول</TextWrapper>
        </Button>
      </form>
    </div>
  );
};

export default LoginPage;
